// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
// import { getFirestore } from 'firebase/firestore';
// import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'demo-api-key',
  authDomain: 'ecpl-web-manager-d567d.firebaseapp.com',
  projectId: 'ecpl-web-manager-d567d',
  storageBucket: 'ecpl-web-manager-d567d.firebasestorage.app',
  messagingSenderId: '221513987686',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'demo-app-id',
  measurementId: 'G-1P5GCDZML8',
};

// Initialize Firebase only if not bypassing auth
let app;
let auth;

if (process.env.REACT_APP_BYPASS_AUTH === 'true') {
  // Mock auth for testing
  auth = {
    currentUser: null,
    onAuthStateChanged: () => () => {} // Return unsubscribe function
  };
} else {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
}

// const analytics = getAnalytics(app);
// const db = getFirestore(app);
// const storage = getStorage(app);
export { auth };
